import { defineStore } from 'pinia'
import { Locale, supportedLocales, defaultLocale } from '@/locales'
const { VITE_APP_NAME } = import.meta.env

export const useSiteStore = defineStore('site', {
  state: () => ({
    navItems:
      VITE_APP_NAME == 'removebg.pro'
        ? [
            // { name: 'header.agentBG', path: '/ai-create?mdx=0' },
            // { name: 'header.refBG', path: '/ai-create?mdx=1' },
            // { name: 'header.chatBG', path: '/ai-create?mdx=2' },
            { name: 'header.assets', path: '/app-assets' },
            { name: 'header.pricing', path: '/pricing' },
          ]
        : [
            // { name: 'header.agentCreate', path: '/ai-create?mdx=0' },
            // { name: 'header.refCreate', path: '/ai-create?mdx=1' },
            // { name: 'header.chatCreate', path: '/ai-create?mdx=2' },
            { name: 'header.removebg', path: '/removebg' },
            { name: 'header.assets', path: '/app-assets' },
            { name: 'header.pricing', path: '/pricing' },
          ],
    curNavIndex: -1,
    theme: 'light',
    locale: defaultLocale,
    supportedLocales,
  }),
  actions: {
    setCurNavIndex(index: number) {
      this.curNavIndex = index
    },
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light'
    },
    setLocale(newLocale: Locale) {
      this.locale = newLocale
      localStorage.setItem('locale', newLocale)
    },
  },
})
